import React, { useEffect, useState } from "react";
import { BsPencil } from "react-icons/bs";
import { MdCasino, MdOutlineCancel, MdOutlineCasino } from "react-icons/md";
import { LuCircleUserRound } from "react-icons/lu";
import { CgArrowsExchange, CgWebsite } from "react-icons/cg";
import { GrShieldSecurity } from "react-icons/gr";
import Level from "./Level";
import DepositBonus from "./DepositBonus";
import BetCommissionLevel from "./LevelCommission/BetCommissionLevel";
import DepositCommissionLevel from "./LevelCommission/DepositCommissionLevel";
import StateList from "./StateRestrictions/StateList";
import axios from "axios";
import WebsiteConfig from "./WebsiteConfig";
import Transactions from "./Transactions";
import SpinSettings from "./SpinSettings";

const Setting = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedTimeZone, setSelectedTimeZone] = useState("Asia/Calcutta");
  const [tempTimeZone, setTempTimeZone] = useState(selectedTimeZone);
  const [websitetab, setWebsitetab] = useState("default");

  const timeZones = [
    "Asia/Calcutta",
    "Asia/Kolkata",
    "America/New_York",
    "Europe/London",
    "Asia/Tokyo",
    "Australia/Sydney",
  ];

  const handleSaveui = () => {
    setSelectedTimeZone(tempTimeZone);
    setIsEditing(false);
  };

  const handleCancelui = () => {
    setTempTimeZone(selectedTimeZone);
    setIsEditing(false);
  };

  // Generic handlers for each field

  const tabData = [
    {
      id: "Website",
      label: "Website",
      icon: <CgWebsite />,
      content: (
        <div>
          <div className="p-4"></div>
          <div className="mantine-Tabs-tabsList !m-0 flex bg-white !p-0 mantine-fq0g4p">
            <button
              className={`mantine-UnstyledButton-root mantine-Tabs-tab border-blue-500 flex-1 cursor-pointer rounded-t-lg py-3 font-semibold hover:!bg-blue-50 mantine-1hher0m ${
                websitetab === "default" ? "border-b-2 border-[#228BE6]" : ""
              }`}
              onClick={() => setWebsitetab("default")}
            >
              <span>
                <div className="flex justify-center gap-2">Default</div>
              </span>
            </button>
          </div>
          <WebsiteConfig />
        </div>
      ),
    },
    {
      id: "Transaction",
      label: "Transaction",
      icon: <CgArrowsExchange />,
      content: (
        <div>
          <div className="p-4"></div>
          <div className="mantine-Tabs-tabsList !m-0 flex bg-white !p-0 mantine-fq0g4p">
            <button
              className={`mantine-UnstyledButton-root mantine-Tabs-tab border-blue-500 flex-1 cursor-pointer rounded-t-lg py-3 font-semibold hover:!bg-blue-50 mantine-1hher0m ${
                websitetab === "default" ? "border-b-2 border-[#228BE6]" : ""
              }`}
              onClick={() => setWebsitetab("default")}
            >
              <span>
                <div className="flex justify-center gap-2">Default</div>
              </span>
            </button>
          </div>
          <Transactions />
        </div>
      ),
    },
    // {
    //   id: "SetSpin",
    //   label: "Spin",
    //   content: (
    //     <div className="p-4">
    //       <SpinSettings />
    //     </div>
    //   ),
    // },
    {
      id: "SetUserLevel",
      label: "User Level",
      content: (
        <div className="p-4">
          <Level />
        </div>
      ),
    },
    {
      id: "SetDepositBonus",
      label: "Deposit Bonus",
      content: (
        <div className="p-4">
          <DepositBonus />
        </div>
      ),
    },
    {
      id: "SetDepositCommissionLevel",
      label: "Deposit Commission Level",
      content: (
        <div className="p-4">
          <DepositCommissionLevel />
        </div>
      ),
    },
    {
      id: "SetBetCommissionLevel",
      label: "Bet Commission Level",
      content: (
        <div className="p-4">
          <BetCommissionLevel />
        </div>
      ),
    },
    // {
    //   id: "stateRestriction",
    //   label: "State Restriction",
    //   content: (
    //     <div className="p-4">
    //       <StateList />
    //     </div>
    //   ),
    // },
  ];

  const [activeTab, setActiveTab] = useState(tabData[0].id);
  return (
    <div className="ml-0 lg:ml-[220px] pl-2">
      <div className="my-5">
        <div className="flex justify-between items-center">
          <div className="w-auto">
            <h1 className="font mb-3 flex flex-wrap items-center text-lg font-bold text-stone-700 md:text-xl">
              SETTINGS
            </h1>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <a className="font-semibold text-[#6B7280]" href="/settings?tab=ui#">
            Settings<span className="ml-2">/</span>
          </a>
          <a className="font-semibold text-[#6B7280]" href="/settings?tab=ui#">
            {activeTab}
          </a>
        </div>
      </div>

      <div className="w-full min-w-[14rem]  overflow-auto rounded-lg bg-neutral-200">
        <section>
          <div className="flex w-full flex-col justify-center rounded-lg">
            <div
              className="flex bg-white rounded-lg"
              role="tablist"
              aria-orientation="horizontal"
            >
              {tabData.map((tab) => (
                <button
                  key={tab.id}
                  className={`flex-1 px-4 py-2 text-center text-[14px] border-b-2 hover:bg-[#F5F5F4] ${
                    activeTab === tab.id
                      ? " border-[#228BE6]"
                      : "  border-transparent"
                  }`}
                  onClick={() => setActiveTab(tab.id)}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === tab.id}
                >
                  <span className="inline-flex items-center gap-2">
                    <div>{tab.icon}</div>
                    <span>{tab.label}</span>
                  </span>
                </button>
              ))}
            </div>

            <div className="gap grid rounded-lg">
              {tabData.find((tab) => tab.id === activeTab)?.content}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Setting;
